<ng-container
  *ngIf="{
    responseId: responseId$ | async
  } as data"
>
  <cng-contact-view-layout>
    <ng-template cngContactViewLayoutActions>
      <chat-script-redirection-actions [responseId]="data.responseId"></chat-script-redirection-actions>
    </ng-template>
    <ng-template cngContactViewLayoutWorkspace>
      <chat-transfer-workspace [responseId]="data.responseId"></chat-transfer-workspace>
    </ng-template>
  </cng-contact-view-layout>
</ng-container>
